









































import { Component, Vue } from "vue-property-decorator";
import { IOffer } from "@/store/interfaces/offer";
import OfferCard from "@/components/offer/OfferCard.vue";
import api from "@/api/index.ts";
import { mapGetters } from "vuex";
import ProductsHelper from "@/components/common/preloaders/ProductsHelper.vue";
import OfferPreload from "@/components/common/preloaders/OfferPreload.vue";

@Component({
  name: "ProductsContent",
  components: {
    OfferCard,
    ProductsHelper,
    OfferPreload
  },
  computed: mapGetters("products", [
    "getProducts",
    "getCategories",
    "getCount",
    "getCategory",
    "getNextCursor",
    "getPrevCursor",
    "getCurrentCursor",
    "isLangChanging"
  ])
})
export default class ProductsContent extends Vue {
  getCategory: any;
  getCategories: any[];
  getNextCursor: string;
  getPrevCursor: string;
  getCurrentCursor: string;
  isLangChanging: boolean;
  isLoading: boolean = true;

  async beforeMount() {
    await this.$store.dispatch("products/getCategories");
    if (!location.search) {
      const categoryID = this.getCategories[0]["category_id"];
      this.$store
        .dispatch("products/fetchProducts", [categoryID, 20, ""])
        .then(() => {
          this.isLoading = false;
        });
      this.$router.push({ path: `/products?category=${categoryID}` });
    } else {
      let category = decodeURIComponent(
        location.search.split("&count")[0].split("=")[1]
      );
      let count = "";
      if (location.search.split("&count").length === 2) {
        count = location.search.split("&count")[1].split("=")[1];
      }
      this.$store
        .dispatch("products/fetchProducts", [category, 20, count])
        .then(() => {
          this.isLoading = false;
        });
    }
  }

  readyText(text) {
    this.isLoading = false;
  }

  nextPage() {
    this.isLoading = true;
    this.$store
      .dispatch("products/fetchProducts", [
        this.getCategory,
        20,
        this.getNextCursor
      ])
      .then(() => {
        this.isLoading = false;
      });

    this.$router.push({
      path: `/products?category=${this.getCategory}&count=${this.getNextCursor}`
    });
  }

  prevPage() {
    this.isLoading = true;
    this.$store
      .dispatch("products/fetchProducts", [
        this.getCategory,
        20,
        this.getPrevCursor
      ])
      .then(() => {
        this.isLoading = false;
      });

    this.$router.push({
      path: `/products?category=${this.getCategory}&count=${this.getPrevCursor}`
    });
  }

  onChangeFirst(item) {
    this.isLoading = true;
    this.$store
      .dispatch("products/fetchProducts", [item.category_id, 20, ""])
      .then(() => {
        this.isLoading = false;
      });
    this.$router.push({ path: `/products?category=${item.category_id}` });
  }

  getCurrentCategoryName() {
    const currentCat = this.getCategories.filter(cat => {
      return this.getCategory === cat["category_id"];
    })[0];

    return currentCat ? currentCat.name : "";
  }
}
